import PropTypes from 'prop-types';

import { evisortBlue } from '../../../assets/shared-styles/general';

const ExpiringIcon = ({
  size = '16',
  color = '#FFF',
  opacity = '1',
  isActive,
}) => {
  const iconColor = isActive ? evisortBlue : color;
  const iconOpacity = isActive ? '1' : opacity;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill={iconColor}
          fillRule="nonzero"
          fillOpacity={iconOpacity}
          d="M13.26 3C8.17 2.86 4 6.95 4 12H2.21c-.45 0-.67.54-.35.85l2.79 2.8c.2.2.51.2.71 0l2.79-2.8a.5.5 0 0 0-.36-.85H6c0-3.9 3.18-7.05 7.1-7 3.72.05 6.85 3.18 6.9 6.9.05 3.91-3.1 7.1-7 7.1-1.61 0-3.1-.55-4.28-1.48a.994.994 0 0 0-1.32.08c-.42.42-.39 1.13.08 1.49A8.858 8.858 0 0 0 13 21c5.05 0 9.14-4.17 9-9.26-.13-4.69-4.05-8.61-8.74-8.74zm-.51 5c-.41 0-.75.34-.75.75v3.68c0 .35.19.68.49.86l3.12 1.85c.36.21.82.09 1.03-.26.21-.36.09-.82-.26-1.03l-2.88-1.71v-3.4c0-.4-.34-.74-.75-.74z"
        />
      </g>
    </svg>
  );
};

ExpiringIcon.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string,
  opacity: PropTypes.string,
  isActive: PropTypes.bool,
};

export default ExpiringIcon;
